import { pipe } from 'fp-ts/function';
import {
    PortfolioCentralPaymentPoliciesAddParameters,
    PortfolioCentralPaymentPolicy,
    PortfolioCentralPaymentPolicyDetail,
    PortfolioSettlementValueType,
    SettlementRuleDetailResult,
    SettlementRuleResult,
} from '@mews-commander/data-access';
import { DurationService } from '@mews/framework';
import { SettlementRuleOffsetType } from '../../settlementRules/types';
import { FormValues } from './components/forms/schema';
import { CentralPaymentPolicyFormField } from './components/forms/types';

export const isCentralPaymentPolicy = (
    data:
        | SettlementRuleResult
        | SettlementRuleDetailResult
        | PortfolioCentralPaymentPolicyDetail
        | PortfolioCentralPaymentPolicy
): data is PortfolioCentralPaymentPolicyDetail | PortfolioCentralPaymentPolicy =>
    Object.hasOwn(data, 'percentageValue');

export const preparePaymentPolicyValues = (values: FormValues): PortfolioCentralPaymentPoliciesAddParameters => {
    const { name, key, offsetType, amount, ...rest } = values;

    const durationOffset = DurationService.fromObject(values.offset);

    return {
        ...rest,
        [CentralPaymentPolicyFormField.Name]: name || null,
        [CentralPaymentPolicyFormField.PaymentPolicyKey]: key || null,
        [CentralPaymentPolicyFormField.Offset]:
            offsetType === SettlementRuleOffsetType.Before
                ? pipe(durationOffset, DurationService.negate, DurationService.toString)
                : pipe(durationOffset, DurationService.toString),
        value: {
            discriminator:
                amount.type === 'percentage'
                    ? PortfolioSettlementValueType.Percentage
                    : PortfolioSettlementValueType.Flat,
            value: {
                value: amount.value,
            },
        },
    };
};
